import store from '../store/officialStore';
import gameInfoConfig from '@configs/officialStore/globalGameInfoConfig';
import globalConfig from '@utiles/officialStore/globalConfig';
import { pageType, viewPage } from '@plugins/biPoint/_configWebstoreV1';

export default [
  {
    path: '/',
    name: 'home',
    meta: {
      pageName: pageType.homePage
    },
    component: () => import('@views/officialStore/Home.vue'),
    beforeEnter: (_to, _from, next) => {
      viewPage(pageType.homePage);
      next();
    }
  },
  {
    path: '/result',
    name: 'result',
    meta: {
      pageName: pageType.resultPage
    },
    component: () => import('@views/officialStore/Result.vue'),
    beforeEnter: (_to, _from, next) => {
      viewPage(pageType.resultPage);
      next();
    }
  },
  {
    path: '/vip_score',
    name: 'vipScore',
    meta: {
      pageName: pageType.vipPage
    },
    component: () => import('@views/officialStore/VipPage.vue'),
    beforeEnter: (_to, _from, next) => {
      viewPage(pageType.vipPage);
      next();
    }
  },
  {
    path: '/share_event',
    name: 'shareEvent',
    component: () => import('@views/officialStore/SharePage.vue')
  },
  {
    path: '/bank_info',
    name: 'bankInfo',
    meta: {
      index: 3,
      pageName: pageType.bankPage
    },
    component: () => import('@views/officialStore/BankDetailInfo.vue'),
    beforeEnter: (_to, _from, next) => {
      viewPage(pageType.bankPage);
      next();
    }
  },
  {
    path: '/coins',
    name: 'coins',
    meta: {
      pageName: pageType.balanceTopupPage
    },
    component: () => import('@views/officialStore/Coins.vue'),
    beforeEnter: (_to, _from, next) => {
      if (new Date().getTime() >= new Date('2025-08-18 00:00:00Z').getTime()) {
        next('/');
        return;
      }
      const gameId =
        store.state.gameId ||
        globalConfig.getHrefParam('gameId') ||
        globalConfig.getHrefParam('gameID') ||
        globalConfig.getHrefParam('game_id');
      if (gameInfoConfig[gameId] && gameInfoConfig[gameId].isUpdateNewVersion) {
        viewPage(pageType.balanceTopupPage);
        next();
      } else {
        next('/');
      }
    }
  },
  {
    path: '/wallet',
    name: 'wallet',
    component: () => import('@views/officialStore/Wallet.vue'),
    meta: {
      pageName: pageType.balancePage
    },
    beforeEnter: (_to, _from, next) => {
      const gameId = store.state.gameId;
      if (
        store.state.login.isLogin &&
        gameInfoConfig[gameId] &&
        gameInfoConfig[gameId].isUpdateNewVersion
      ) {
        viewPage(pageType.balancePage);
        next();
      } else {
        next('/');
      }
    }
  },
  {
    path: '/browserPay',
    name: 'browserPay',
    meta: {
      pageName: pageType.browserPay
    },
    component: () => import('@views/officialStore/BrowserPaying.vue'),
    beforeEnter: (_to, _from, next) => {
      viewPage(pageType.browserPay);
      next();
    }
  },
  // 匹配其他不存在的路由跳转回首页
  {
    path: '*',
    redirect: '/'
  }
];
